var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _core = require("../core");
var _FrameCallbackRegistryUI = require("./FrameCallbackRegistryUI");
var _worklet_9769030538367_init_data = {
    code: "function anonymous(){const{callback,callbackId}=this.__closure;global._frameCallbackRegistry.registerFrameCallback(callback,callbackId);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/frameCallback/FrameCallbackRegistryJS.ts",
    sourceMap: '{"version":3,"names":["anonymous","callback","callbackId","__closure","global","_frameCallbackRegistry","registerFrameCallback"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/frameCallback/FrameCallbackRegistryJS.ts"],"mappings":"AAmBY,SAAAA,SAAMA,CAAA,QAAAC,QAAA,CAAAC,UAAA,OAAAC,SAAA,CACZC,MAAM,CAACC,sBAAsB,CAACC,qBAAqB,CAACL,QAAQ,CAAEC,UAAU,CAAC,CAC3E"}',
    version: "3.5.4"
};
var _worklet_3563696229796_init_data = {
    code: "function anonymous(){const{callbackId}=this.__closure;global._frameCallbackRegistry.unregisterFrameCallback(callbackId);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/frameCallback/FrameCallbackRegistryJS.ts",
    sourceMap: '{"version":3,"names":["anonymous","callbackId","__closure","global","_frameCallbackRegistry","unregisterFrameCallback"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/frameCallback/FrameCallbackRegistryJS.ts"],"mappings":"AA2BY,SAAAA,SAAMA,CAAA,QAAAC,UAAA,OAAAC,SAAA,CACZC,MAAM,CAACC,sBAAsB,CAACC,uBAAuB,CAACJ,UAAU,CAAC,CACnE"}',
    version: "3.5.4"
};
var _worklet_12225017345728_init_data = {
    code: "function anonymous(){const{callbackId,state}=this.__closure;global._frameCallbackRegistry.manageStateFrameCallback(callbackId,state);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/frameCallback/FrameCallbackRegistryJS.ts",
    sourceMap: '{"version":3,"names":["anonymous","callbackId","state","__closure","global","_frameCallbackRegistry","manageStateFrameCallback"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/frameCallback/FrameCallbackRegistryJS.ts"],"mappings":"AAiCY,SAAAA,SAAMA,CAAA,QAAAC,UAAA,CAAAC,KAAA,OAAAC,SAAA,CACZC,MAAM,CAACC,sBAAsB,CAACC,wBAAwB,CAACL,UAAU,CAAEC,KAAK,CAAC,CAC3E"}',
    version: "3.5.4"
};
var FrameCallbackRegistryJS = exports.default = function() {
    function FrameCallbackRegistryJS() {
        (0, _classCallCheck2.default)(this, FrameCallbackRegistryJS);
        this.nextCallbackId = 0;
        (0, _FrameCallbackRegistryUI.prepareUIRegistry)();
    }
    (0, _createClass2.default)(FrameCallbackRegistryJS, [
        {
            key: "registerFrameCallback",
            value: function registerFrameCallback(callback) {
                if (!callback) {
                    return -1;
                }
                var callbackId = this.nextCallbackId;
                this.nextCallbackId++;
                (0, _core.runOnUI)(function() {
                    var _e = [
                        new global.Error(),
                        -3,
                        -27
                    ];
                    var anonymous = function anonymous() {
                        global._frameCallbackRegistry.registerFrameCallback(callback, callbackId);
                    };
                    anonymous.__closure = {
                        callback: callback,
                        callbackId: callbackId
                    };
                    anonymous.__initData = _worklet_9769030538367_init_data;
                    anonymous.__workletHash = 9769030538367;
                    anonymous.__stackDetails = _e;
                    return anonymous;
                }())();
                return callbackId;
            }
        },
        {
            key: "unregisterFrameCallback",
            value: function unregisterFrameCallback(callbackId) {
                (0, _core.runOnUI)(function() {
                    var _e = [
                        new global.Error(),
                        -2,
                        -27
                    ];
                    var anonymous = function anonymous() {
                        global._frameCallbackRegistry.unregisterFrameCallback(callbackId);
                    };
                    anonymous.__closure = {
                        callbackId: callbackId
                    };
                    anonymous.__initData = _worklet_3563696229796_init_data;
                    anonymous.__workletHash = 3563696229796;
                    anonymous.__stackDetails = _e;
                    return anonymous;
                }())();
            }
        },
        {
            key: "manageStateFrameCallback",
            value: function manageStateFrameCallback(callbackId, state) {
                (0, _core.runOnUI)(function() {
                    var _e = [
                        new global.Error(),
                        -3,
                        -27
                    ];
                    var anonymous = function anonymous() {
                        global._frameCallbackRegistry.manageStateFrameCallback(callbackId, state);
                    };
                    anonymous.__closure = {
                        callbackId: callbackId,
                        state: state
                    };
                    anonymous.__initData = _worklet_12225017345728_init_data;
                    anonymous.__workletHash = 12225017345728;
                    anonymous.__stackDetails = _e;
                    return anonymous;
                }())();
            }
        }
    ]);
    return FrameCallbackRegistryJS;
}();
